import { useEffect, useRef } from 'react'
import { IcaCardRowLink } from '../IcaElements/IcaCardRowLink'
import '@ica-azure/ica-elements/IcaIconAlarm'
import '@ica-azure/ica-elements/IcaIconTrash'
import { IcaMediaObject } from '../IcaElements/IcaMediaObject'
import { IcaCard } from '../IcaElements/IcaCard'

interface GroceryItemPopoverProps {
  onEdit: () => void
  onDelete: () => void
  onClose: () => void
}

export default function GroceryFeedItemPopover({ onEdit, onDelete, onClose }: GroceryItemPopoverProps) {
  const popoverRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  return (
    <div ref={popoverRef} className="absolute right-0 mt-2 z-50 w-[260px] shadow-[0_4px_16px_#0000001f,0_1px_3px_#00000014] rounded-xl overflow-hidden" role="menu">
      <IcaCard nogutters>
        <IcaCardRowLink
          className="px-3 py-2"
          onClick={() => { onEdit(); onClose() }}
        >
          <IcaMediaObject>
            <tgdb-ica-icon-alarm slot="first" />
            <div slot="last">
              <div className="font-medium">Saldoinställningar</div>
              <div className="text-[13px] text-[var(--color-grey-mid-light)]">Maxsaldo & gränsvärde</div>
            </div>
          </IcaMediaObject>
        </IcaCardRowLink>
        <IcaCardRowLink
          className="px-3 py-2"
          onClick={() => { onDelete(); onClose() }}
        >
          <IcaMediaObject>
            <tgdb-ica-icon-trash slot="first" style={{ color: 'var(--color-accent-red)' }} />
            <div slot="last">
              <span className="text-[var(--color-accent-red)] font-medium">Ta bort från varuskåp</span>
            </div>
          </IcaMediaObject>
        </IcaCardRowLink>
      </IcaCard>
    </div>
  )
}
